// ===============================
//  COMPONENTE CORREGIDO COMPLETO
// ===============================

import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import logotiposplash from "../../../images/logosinestry.png";
import Configuracion from "../../../data/configuracion";
import apibig from "../../../components/Apibig";
import DynamicIcon from "../../../components/DynamicIcon";


// ===============================
//  SUBMENÚ MULTINIVEL
// ===============================
const SplashMenu = ({
  menus,
  nivel = 0,
  openSubmenus,
  setOpenSubmenus,
  parentKey = "root",
}) => {
  const hasChildren = Array.isArray(menus.menus) && menus.menus.length > 0;
  const submenuKey = menus.clave || menus.Titulo || `submenu-${nivel}`;

  const openKeyAtLevel = openSubmenus[parentKey];
  const isOpen = openKeyAtLevel === submenuKey;

  const toggleSubmenu = (e) => {
    e.preventDefault();

    setOpenSubmenus((prev) => {
      if (prev[parentKey] === submenuKey) {
        const copy = { ...prev };
        delete copy[parentKey];

        Object.keys(copy).forEach((key) => {
          if (key.startsWith(submenuKey)) delete copy[key];
        });

        return copy;
      } else {
        return { ...prev, [parentKey]: submenuKey };
      }
    });
  };

  // Detectar si es ventana externa
  const esExterno =
    menus.Win ||
    menus.target === "_blank" ||
    menus.id === 59;

  return (
    <div style={{ paddingLeft: nivel * 20 }} className="py-1">

      {/* BOTÓN DEL MENÚ O SUBMENÚ */}
      <div
        className="flex justify-between items-center cursor-pointer text-blue-800 hover:text-white hover:bg-sidebar-100 rounded-md p-1"
      >
        {/* ENLACES ORDENADOS */}
        {menus.Ruta || menus.URL ? (
          <a
            href={menus.Win ? menus.URL : menus.id !== 59 ? `#${menus.Ruta}` : menus.Ruta}
            target={esExterno ? "_blank" : "_self"}
            rel="noopener noreferrer"
            className="flex items-center w-full"
            onClick={(e) => {
              if (hasChildren) {
                e.preventDefault();
                toggleSubmenu(e);
              }
            }}
          >
            {menus.Icono && (
              <span className="mr-2">
                <DynamicIcon iconName={menus.Icono} size="1rem" />
              </span>
            )}
            {menus.Titulo}
          </a>
        ) : (
          <Link
            to={menus.Ruta || "#"}
            className="flex items-center w-full text-[10px]"
            onClick={(e) => {
              if (hasChildren) {
                e.preventDefault();
                toggleSubmenu(e);
              }
            }}
          >
            {menus.Icono && (
              <span className="mr-2">
                <DynamicIcon iconName={menus.Icono} size="1rem" />
              </span>
            )}
            {menus.Titulo}
          </Link>
        )}

        {/* Icono de abrir/cerrar */}
        {hasChildren && (
          <span
            className="ml-2 select-none text-[10px] cursor-pointer"
            onClick={toggleSubmenu}
          >
            {isOpen ? "▲" : "▼"}
          </span>
        )}
      </div>

      {/* SUBMENÚ */}
      {hasChildren && isOpen && (
        <div className="border-l border-gray-300 mt-1 text-[10px]">
          {menus.menus.map((submenu, idx) => (
            <SplashMenu
              key={submenu.clave || idx}
              menus={submenu}
              nivel={nivel + 1}
              openSubmenus={openSubmenus}
              setOpenSubmenus={setOpenSubmenus}
              parentKey={submenuKey}
            />
          ))}
        </div>
      )}
    </div>
  );
};


// ===============================
//  MENÚ PRINCIPAL
// ===============================
const Menuprincipal = ({ menu }) => {
  const [openClave, setOpenClave] = useState(null);
  const [openSubmenus, setOpenSubmenus] = useState({});

  const toggleMainMenu = () => {
    setOpenClave((prev) => (prev === menu.clave ? null : menu.clave));
    setOpenSubmenus({});
  };

  const esExterno =
    menu.Win ||
    menu.target === "_blank";

  if (menu.menus?.length > 0) {
    return (
      <div>
        <div
          className={`cursor-pointer flex justify-between bg-menusplash-200 text-white rounded-[23rem] h-[2rem] px-6 hover:hover:bg-menusplash-100 transition  text-[12px] w-full ${
            openClave === menu.clave ? "bg-menusplash-100" : "bg-menusplash-200"
          }`}
        >
          <div onClick={toggleMainMenu} className="flex justify-center items-center">
            <DynamicIcon iconName={menu.Icono} />
            <span className="ml-2">{menu.Titulo}</span>

            {menu.menus?.length > 0 && (
              <span className="ml-2 text-xs">{openClave === menu.clave ? "▲" : "▼"}</span>
            )}
          </div>
        </div>

        {openClave === menu.clave && (
          <ul className="absolute flex flex-col justify-start z-50 ml-[1rem] bg-menusplash-300 text-black rounded-md shadow-lg w-[20rem] overflow-auto p-1">
            {menu.menus.map((submenu, idx) => (
              <li key={submenu.clave || idx}>
                <SplashMenu
                  menus={submenu}
                  openSubmenus={openSubmenus}
                  setOpenSubmenus={setOpenSubmenus}
                  parentKey={menu.clave}
                />
              </li>
            ))}
          </ul>
        )}
      </div>
    );
  }

  // MENÚ SIN SUBMENÚS
  return (
    <div
      className={`cursor-pointer flex justify-center bg-menusplash-200 text-white rounded-[23rem] h-[2rem] px-6 hover:bg-menusplash-100 transition text-[12px] w-full`}
    >
      {esExterno ? (
        <a
          href={menu.URL || menu.Ruta}
          target="_blank"
          rel="noopener noreferrer"
          className="flex justify-start items-center w-full"
        >
          <DynamicIcon iconName={menu.Icono} />
          <span className="ml-2">{menu.Titulo}</span>
        </a>
      ) : (
        <Link to={menu.Ruta} className="flex justify-start items-center w-full">
          <DynamicIcon iconName={menu.Icono} />
          <span className="ml-2">{menu.Titulo}</span>
        </Link>
      )}
    </div>
  );
};


// ===============================
//  PAGINA SPLASH
// ===============================
const Splash = ({ autusuario, permisos }) => {
  const [datapermisos, setDatapermisos] = useState(permisos.permisos || []);

  useEffect(() => {
    const fetchroles = async () => {
      try {
        const response = await apibig.post("/api/permisos/getpermisosxusuario", {
          appid: Configuracion.proyecto,
          email: autusuario.email,
          basedatos: Configuracion.basedatos,
        });

        sessionStorage.setItem("data", JSON.stringify(response.data));
        const cnt = JSON.parse(sessionStorage.getItem("data"));
        setDatapermisos(cnt.permisos);
      } catch (error) {
        console.error("Error al obtener permisos:", error);
      }
    };

    fetchroles();
  }, [autusuario]);

  return (
    <div className="flex flex-col min-h-screen bg-gray-100 items-center justify-center p-4">
      <div className="w-[90%] max-w-screen-xl bg-white rounded-[2vw] shadow-xl p-6 space-y-6 my-10">

        {/* LOGO */}
        <div className="flex flex-col items-center">
          <img src={logotiposplash} className="w-[14rem]" alt="logo" />
          <h1 className="text-2xl font-bold text-center text-titulo1splash-100 mt-2">
            Bienvenido a siniestrosApp
          </h1>
          <p className="text-center text-[.8rem] text-titulo2splash-100 mt-2 max-w-3xl">
            Aquí encontrarás la administración para la operación de la cuenta.
          </p>
        </div>

        {/* MENÚS */}
        <div className="h-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-1">
          {datapermisos.map((menu, idx) => (
            <Menuprincipal key={menu.clave || idx} menu={menu} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Splash;
